export default __webpack_public_path__ + "62f99fe6dcc6598b0ff49395bd5585be.png";